<div class="d-flex flex-column justify-content-center text-center">
    <div class="mx-2">View and edit your personal info and preferences with Focus POS users.</div>
    <div *ngIf="!awaitValidation" class="">
        <p-divider>Find me by</p-divider>
        <div class="p-field-radiobutton">
            <p-radioButton #emailSearch name="searchMethod" value="email" [(ngModel)]="searchMethod"
                (onClick)="phoneValue = undefined"></p-radioButton>
            <label for="emailSearch">Email Address</label>
        </div>

        <div class="p-field-radiobutton">
            <p-radioButton #phoneSearch name="searchMethod" value="phone" [(ngModel)]="searchMethod"
                (onClick)="emailValue = undefined"></p-radioButton>
            <label for="phoneSearch">Phone Number</label>
        </div>
        <div class="d-flex flex-column flex-fill w-100">
            <div class="mx-2">
                <div *ngIf="searchMethod === 'email'">
                    <input pInputText #emailInput [formControl]="controlEmailField" name="emailInput" type="text"
                        [(ngModel)]="emailValue" class="w-100 text-center" placeholder="hscorpio@globexco.com" />
                </div>

                <div *ngIf="controlEmailField.errors">
                    <div *ngIf="controlEmailField.hasError('email')">
                        Your email address does not match the proper format.
                    </div>
                </div>
                <div *ngIf="searchMethod === 'phone'">
                    <p-inputMask #phoneInput [formControl]="controlPhoneField" name="phoneInput" mask="(999) 999-9999"
                        [(ngModel)]="phoneValue" placeholder="(999) 999-9999" styleClass="w-100 text-center">
                    </p-inputMask>
                </div>

                <div *ngIf="!controlPhoneField.pristine && controlPhoneField.errors">
                    <div *ngIf="controlPhoneField.hasError('invalidPhonePatternValue')">
                        Your phone number does not match the proper format.
                    </div>
                </div>
            </div>


            <p-button pRipple
                [disabled]="((!emailValue && controlPhoneField.errors) || (!phoneValue && controlEmailField.errors))"
                styleClass="p-button-raised p-button-info m-2" (click)="onRequestValidationCode()">
                <ng-template pTemplate="content">
                    <div class="d-flex justify-content-center">
                        <fa-icon [icon]='["far","badge-check"]' size="lg" class="ms-1 me-2"></fa-icon>
                        Send me a code
                    </div>
                </ng-template>
            </p-button>
        </div>
    </div>
    <app-about-me-validation *ngIf="awaitValidation" [(awaitValidation)]="awaitValidation"
        [validationCode]="validationCode" [customerKey]="customerKey"
        (validationSuccessChange)="onValidationResponse($event)"></app-about-me-validation>
</div>